/**
 * Retorno do OAuth do GitLab: troca o `code` pelo vínculo.
 *
 * Aberta pela janela do cartão, avisa o Perfil e se fecha. Aberta na página
 * inteira (navegador que bloqueia a janela), volta sozinha ao Perfil.
 */
import { useEffect, useRef, useState } from 'react'
import { Anchor, Stack, Text } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { concluirVinculoGitlab } from '@/api/gitlabIdentidade'
import { janelaDoCartao, TIPO_RESULTADO, type ResultadoVinculo } from './gitlabJanela'

const RECUSADO = 'O vínculo não foi autorizado no GitLab. Nada mudou.'
const FALHOU = 'Não consegui concluir o vínculo. Tente Conectar GitLab de novo.'

export function GitlabCallback() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [texto, setTexto] = useState('Conectando ao GitLab…')
  const feito = useRef(false)  // StrictMode roda o efeito duas vezes; o state é de uso único
  useEffect(() => {
    if (feito.current) return
    feito.current = true
    const cartao = janelaDoCartao()
    const concluir = (r: ResultadoVinculo) => {
      if (cartao) {
        cartao.postMessage(r, window.location.origin)
        window.close()
        return
      }
      if (r.ok) {
        notifications.show({ color: 'teal', title: 'GitLab conectado',
                             message: `Conectado como ${r.gitlab_username}.` })
        navigate('/perfil', { replace: true })
      } else {
        setTexto(r.motivo)
      }
    }
    const code = params.get('code'), state = params.get('state')
    if (params.get('error') || !code || !state) {
      concluir({ tipo: TIPO_RESULTADO, ok: false, motivo: RECUSADO })
      return
    }
    concluirVinculoGitlab(code, state)
      .then((r) => concluir({ tipo: TIPO_RESULTADO, ok: true, gitlab_username: r.gitlab_username }))
      .catch((e) => concluir({ tipo: TIPO_RESULTADO, ok: false,
                               motivo: e?.response?.data?.detail?.motivo ?? FALHOU }))
  }, [params, navigate])
  return (
    <Stack p="md" gap="xs">
      <Text>{texto}</Text>
      <Anchor component={Link} to="/perfil" size="sm">Voltar ao perfil</Anchor>
    </Stack>
  )
}
